import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { IPriceMismatchResponse } from '../interfaces/price-mismatch.interface';

@Injectable({
    providedIn: 'root'
})
export class PriceMismatchService {
    http = inject(HttpClient);
    baseUrl = environment.apiUrl;

    getPriceMismatch(beginDate: string, endDate: string): Observable<IPriceMismatchResponse> {
        const apiUrl = `${this.baseUrl}/dashboard/priceMismatch`;

        let params = new HttpParams().set('beginDate', beginDate).set('endDate', endDate);

        return this.http.get<IPriceMismatchResponse>(apiUrl, { params });
    }
}
